<template>
  <fh-container>
    <fh-title>Cambiar Correo Electrónico</fh-title>

    <fh-card>
      <v-form ref="form" @submit.prevent="handleChangeEmail" v-model="valid" lazy-validation>

        <!-- Email -->
        <v-text-field
          :rules="emailRules"
          label="Correo Electrónico"
          v-model="email"
          autocomplete="email"
          inputmode="email"
          autofocus
        ></v-text-field>

        <v-row justify="center" class="pt-3">
          <v-btn @click="handleChangeEmail" color="primary">
            Cambiar
          </v-btn>
        </v-row>

      </v-form>
    </fh-card>
  </fh-container>
</template>

<script>
import FhContainer from '@/components/FhContainer'
import FhTitle from '@/components/FhTitle'
import FhCard from '@/components/FhCard'
import { mapActions } from 'vuex'

export default {
  name: 'ChangeEmail',
  components: { FhCard, FhTitle, FhContainer },
  data () {
    return {
      valid: true,
      // Defer validation until first submit attempt
      isSubmit: false,
      email: '',
      emailRules: [
        v => !!v || 'Campo obligatorio',
        v => !this.isSubmit || /^\S+@\S+$/.test(v) || 'Correo Electrónico no válido'
      ],
    }
  },
  methods: {
    ...mapActions('snackbar', [
      'showSnackbar'
    ]),
    ...mapActions('user', [
      'changeEmail'
    ]),
    async handleChangeEmail () {
      try {
        this.isSubmit = true
        if (!this.$refs.form.validate()) { return }

        await this.changeEmail([this.email])
        this.showSnackbar(['Cambio de correo electrónico exitoso.', 'success'])
        this.$router.push({ name: 'Home' })
      } catch (e) {
        //
      }
    }
  },
}
</script>

<style scoped>

</style>
